function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Input } from "../input/input.component";
import { List } from "../list/list.component";
import { Popover } from "../popover/popover.component";

/**
 * Autocomplete is a normal text input enhanced by a panel of suggested options.
 *
 * @extends React.Component
 *
 * @method {() => void} show - Sets data list visible.
 *
 * @method {() => void} hide - Sets data list invisible.
 *
 * @method {() => void} focus - Focuses an input field and sets data list visible.
 *
 * @method {() => void} blur - Removes focus from input field and sets data list invisible.
 *
 * @method {() => boolean} isFocused - Returns true if the input field is currently focused.
 *
 * @method {() => void} clear - Removes all text from the input field.
 *
 * @property {ReactElement<AutocompleteItemProps> | ReactElement<AutocompleteItemProps>[]} children -
 * Options displayed within list.
 *
 * @property {(number) => void} onSelect - Called when option is pressed.
 *
 * @property {string} status - Status of the component.
 * Can be `basic`, `primary`, `success`, `info`, `warning`, `danger` or `control`.
 * Defaults to *basic*.
 * Useful for giving user a hint on the input validity.
 * Use *control* status when needed to display within a contrast container.
 *
 * @property {string} size - Size of the component.
 * Can be `small`, `medium` or `large`.
 * Defaults to *medium*.
 *
 * @property {ReactText | (TextProps) => ReactElement} label - String, number or a function component
 * to render to top of the input field.
 * If it is a function, expected to return a Text.
 *
 * @property {(ImageProps) => ReactElement} accessoryLeft - Function component
 * to render to start of the text.
 * Expected to return an Image.
 *
 * @property {(ImageProps) => ReactElement} accessoryRight - Function component
 * to render to end of the text.
 * Expected to return an Image.
 *
 * @property {string | PopoverPlacement} placement - Position of the options list relative to the input field.
 * Can be `left`, `top`, `right`, `bottom`, `left start`, `left end`, `top start`, `top end`, `right start`,
 * `right end`, `bottom start` or `bottom end`.
 * Defaults to *bottom*.
 *
 * @property {() => void} onFocus - Called when options list becomes visible.
 *
 * @property {() => void} onBlur - Called when options list becomes invisible.
 *
 * @property {InputProps} ...InputProps - Any props applied to Input component.
 *
 * @overview-example AutocompleteSimpleUsage
 * Autocomplete may contain options to be rendered within suggestions list.
 * Options should be provided by passing them to children.
 *
 * @overview-example AutocompleteAccessories
 * Autocomplete may contain accessories by passing `accessoryLeft` or `accessoryRight` props.
 * By default, we expect it to be images.
 *
 * @example AutocompleteHandleKeyboard
 * On mobile devices, options may be overlapped by keyboard.
 * It can be handled with `placement` property.
 *
 * @example AutocompleteAsync
 * For requesting a real-world data by typing, http requests may be sent with debounce.
 */
export class Autocomplete extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      listVisible: false
    });

    _defineProperty(this, "popoverRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "inputRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "show", () => {
      var _this$popoverRef$curr;

      (_this$popoverRef$curr = this.popoverRef.current) === null || _this$popoverRef$curr === void 0 ? void 0 : _this$popoverRef$curr.show();
    });

    _defineProperty(this, "hide", () => {
      var _this$popoverRef$curr2;

      (_this$popoverRef$curr2 = this.popoverRef.current) === null || _this$popoverRef$curr2 === void 0 ? void 0 : _this$popoverRef$curr2.hide();
    });

    _defineProperty(this, "focus", () => {
      var _this$inputRef$curren;

      (_this$inputRef$curren = this.inputRef.current) === null || _this$inputRef$curren === void 0 ? void 0 : _this$inputRef$curren.focus();
    });

    _defineProperty(this, "blur", () => {
      var _this$inputRef$curren2;

      (_this$inputRef$curren2 = this.inputRef.current) === null || _this$inputRef$curren2 === void 0 ? void 0 : _this$inputRef$curren2.blur();
    });

    _defineProperty(this, "isFocused", () => {
      var _this$inputRef$curren3;

      return (_this$inputRef$curren3 = this.inputRef.current) === null || _this$inputRef$curren3 === void 0 ? void 0 : _this$inputRef$curren3.isFocused();
    });

    _defineProperty(this, "clear", () => {
      var _this$inputRef$curren4;

      (_this$inputRef$curren4 = this.inputRef.current) === null || _this$inputRef$curren4 === void 0 ? void 0 : _this$inputRef$curren4.clear();
    });

    _defineProperty(this, "onInputFocus", event => {
      this.setOptionsListVisible();
      this.props.onFocus && this.props.onFocus(event);
    });

    _defineProperty(this, "onInputSubmitEditing", e => {
      this.setOptionsListInvisible();
      this.props.onSubmitEditing && this.props.onSubmitEditing(e);
    });

    _defineProperty(this, "onBackdropPress", () => {
      this.blur();
      this.setOptionsListInvisible();
    });

    _defineProperty(this, "onItemPress", index => {
      if (this.props.onSelect) {
        this.setOptionsListInvisible();
        this.props.onSelect(index);
      }
    });

    _defineProperty(this, "setOptionsListVisible", () => {
      const hasData = this.data.length > 0;
      hasData && this.setState({
        listVisible: true
      });
    });

    _defineProperty(this, "setOptionsListInvisible", () => {
      this.setState({
        listVisible: false
      });
    });

    _defineProperty(this, "renderItem", info => {
      return /*#__PURE__*/React.cloneElement(info.item, {
        onPress: () => this.onItemPress(info.index)
      });
    });

    _defineProperty(this, "renderInputElement", props => {
      return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Input, _extends({}, props, {
        ref: this.inputRef,
        onFocus: this.onInputFocus,
        onSubmitEditing: this.onInputSubmitEditing
      })));
    });
  }

  get data() {
    return React.Children.toArray(this.props.children || []);
  }

  render() {
    const _this$props = this.props,
          {
      placement,
      children
    } = _this$props,
          inputProps = _objectWithoutProperties(_this$props, ["placement", "children"]);

    return /*#__PURE__*/React.createElement(Popover, {
      ref: this.popoverRef,
      style: styles.popover,
      placement: placement,
      visible: this.state.listVisible,
      fullWidth: true,
      anchor: () => this.renderInputElement(inputProps),
      onBackdropPress: this.onBackdropPress
    }, /*#__PURE__*/React.createElement(List, {
      style: styles.list,
      data: this.data,
      bounces: false,
      renderItem: this.renderItem
    }));
  }

}
const styles = StyleSheet.create({
  popover: {
    maxHeight: 192,
    overflow: 'hidden'
  },
  list: {
    flexGrow: 0,
    overflow: 'hidden'
  }
});